import { render, staticRenderFns } from "./ReportServices.vue?vue&type=template&id=08bea118&scoped=true&"
import script from "./ReportServices.vue?vue&type=script&lang=js&"
export * from "./ReportServices.vue?vue&type=script&lang=js&"
import style0 from "./ReportServices.vue?vue&type=style&index=0&id=08bea118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bea118",
  null
  
)

export default component.exports